import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ApiKeyDto } from '../../../models/api-key/dto/api-key.dto';
import { GET_API_KEYS_QUERY_KEY } from './constants';

type Response = { apiKeys: ApiKeyDto[] };

export const useGetApiKeys = (
  organizationId: string,
  includeRevoked = false,
) => {
  const client = useApiClient();
  return useQuery({
    queryKey: [...GET_API_KEYS_QUERY_KEY(organizationId), { includeRevoked }],
    queryFn: () =>
      client.fetchApi<Response, undefined>({
        endpoint: `organizations/${organizationId}/api-keys${includeRevoked ? '?includeRevoked=true' : ''}`,
        method: 'GET',
      }),
    enabled: !!organizationId,
  });
};
